var map = {
	"./company_qualifications.jpg": "a97b",
	"./cszq_banner_0.png": "d130",
	"./cszq_banner_1.png": "5621",
	"./cszq_banner_1_mobile.png": "99a7",
	"./cszq_banner_2.png": "6100",
	"./cszq_banner_2_mobile.png": "92f2",
	"./cszq_banner_3.png": "600a",
	"./cszq_banner_3_mobile.png": "d77c",
	"./cszq_bg.jpg": "f305",
	"./cszq_bg_logo.jpg": "1c52",
	"./cszq_home_right.jpeg": "c265",
	"./cszq_icon.jpg": "f418",
	"./cszq_logo.png": "c90a",
	"./cszq_partners_1.jpg": "32a2",
	"./cszq_partners_10.jpg": "714f",
	"./cszq_partners_11.png": "7160",
	"./cszq_partners_12.jpg": "4506",
	"./cszq_partners_2.jpg": "627b",
	"./cszq_partners_3.jpg": "b926",
	"./cszq_partners_4.jpg": "5a5f",
	"./cszq_partners_5.jpg": "968a",
	"./cszq_partners_6.jpg": "e041",
	"./cszq_partners_7.jpg": "b5ac",
	"./cszq_partners_8.jpg": "2ed2",
	"./cszq_partners_9.jpg": "2e2d",
	"./download_qrcode.jpeg": "df0b",
	"./ercode.png": "19c3",
	"./error.png": "b948",
	"./loading.gif": "f8b2",
	"./sdgs_header.jpg": "4b18",
	"./sdgs_header.png": "a222"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";